<script>
/**
 * @name ConditionalButton
 * @description using props you can conditionally render the same styled button but as
 * different HTML dom elements based on the context how where/when it's rendered.
 * @example
 * In the webGUI launchpad this will render as a <button> that fires `openPopUp(accountRegisterPayload)` when clicked
 * <ConditionalButton
      v-on:btn-click="openPopUp(accountRegisterPayload)"
      routeName="SignIn"
      text="Sign In"
      class="button button-alt w-full mt-8px" />
 */
export default {
  props: {
    hrefUrl: {
      type: [Boolean, URL],
      default: false,
    },
    hrefExternal: {
      type: Boolean,
      default: false,
    },
    routeName: {
      type: String, // specifically Route names from router.js
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {},
};
</script>

<template>
  <router-link v-if="routeName" :to="{ name: routeName }">{{ text }}</router-link>
  <a
    v-else-if="hrefUrl"
    :href="hrefUrl"
    :rel="hrefExternal ? 'noopener noreferrer' : ''"
    :target="hrefExternal ? '_blank' : ''"
  >
    {{ text }}
  </a>
  <button v-else @click="$emit('btn-click')">{{ text }}</button>
</template>
